export default {_name:'image',module:'Field',view:'Element/Image',options:{key:'image',ms:4,sm:4,xs:12}}